'use client';

import Box from '@mui/material/Box';

import { campaignPostGroupColor, CAMPAIGN_POST_GROUP_NONE_LABEL } from 'src/utils/campaign/campaign-post-groups';

import { Label } from 'src/components/label';

/**
 * 시딩 글 그룹 칩 — 색은 이름으로 정해진다(`campaignPostGroupColor` · 라벨 팔레트).
 * 표 칸 · 묶음 머리 · 고르개 · 거르기 목록이 이 하나를 쓴다. `name` 이 없으면 회색 「그룹 없음」.
 */
export function CampaignPostGroupChip({ name }: { name: string | null }) {
  return (
    <Label color={campaignPostGroupColor(name)} sx={{ maxWidth: 140, minWidth: 0 }}>
      {/* ⚠️ `Label` 은 줄 높이가 0 이라 말줄임 칸이 그대로 물려받으면 글자가 잘려 안 보인다 */}
      <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: 1.5 }}>
        {name ?? CAMPAIGN_POST_GROUP_NONE_LABEL}
      </Box>
    </Label>
  );
}
